import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.element.addEventListener("turbo:morph-element", this.schedule)
    this.schedule()
  }

  disconnect() {
    this.element.removeEventListener("turbo:morph-element", this.schedule)
    this.cancel()
  }

  schedule = () => {
    this.cancel()
    this.timeout = setTimeout(() => this.requestSubmit(), 2000)
  }

  cancel() {
    clearTimeout(this.timeout)
  }

  requestSubmit() {
    this.formTarget.requestSubmit()
  }
}
